export default __webpack_public_path__ + "assets/models/dc353a14fbcbd8dc49c29e25f129b77f.glb";